import { useWindowEventListener } from './useWindowEventListener'

export function useHotkey(
  test: (event: KeyboardEvent) => boolean,
  callback: (event: KeyboardEvent) => any,
  condition: any = true,
  options?: boolean | AddEventListenerOptions,
) {
  useWindowEventListener(
    'keydown',
    (event) => {
      if (test(event)) {
        event.preventDefault()
        event.stopPropagation()

        callback(event)
      }
    },
    condition,
    options,
  )
}
